var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageMembershipSilverMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1618_59807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6876 2.02998L21.4286 9.08012C20.8687 9.62389 20.119 9.92806 19.3385 9.92806H12.4444C10.7876 9.92806 9.44444 11.2712 9.44444 12.9281V20.2664C9.44444 21.1053 9.09313 21.906 8.47574 22.474L3.33533 27.2038C2.06734 28.3705 2.04045 30.363 3.27649 31.5635L9.33522 37.4479C9.96825 38.0627 10.2985 38.925 10.2381 39.8054L9.66447 48.1615C9.54547 49.8951 10.9197 51.3669 12.6574 51.3669H21.0712C21.8784 51.3669 22.6515 51.6922 23.2159 52.2692L28.7378 57.9144C29.8735 59.0755 31.7271 59.1219 32.9195 58.019L39.2487 52.1646C39.8032 51.6518 40.5306 51.3669 41.2858 51.3669H50C51.6569 51.3669 53 50.0238 53 48.3669V39.5518C53 38.8207 53.267 38.1148 53.7507 37.5667L59.1074 31.497C60.167 30.2964 60.0969 28.4754 58.9483 27.3598L53.9099 22.4664C53.3282 21.9015 53 21.1252 53 20.3144V12.9281C53 11.2712 51.6569 9.92806 50 9.92806H42.2171C41.4366 9.92806 40.6868 9.62389 40.1269 9.08012L32.8679 2.02998C31.7038 0.899394 29.8517 0.899396 28.6876 2.02998Z",
    fill: "url(#paint0_linear_1618_59807)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.12 34.14C18.82 34.14 19.83 33.11 19.83 31.9C19.83 30.84 19.24 30.26 18.35 29.89L17.38 29.49C16.75 29.24 16.22 29.04 16.22 28.51C16.22 28.03 16.63 27.74 17.28 27.74C17.89 27.74 18.38 27.96 18.86 28.35L19.6 27.42C19 26.81 18.14 26.47 17.28 26.47C15.79 26.47 14.72 27.4 14.72 28.61C14.72 29.68 15.48 30.29 16.22 30.59L17.21 31.01C17.87 31.29 18.32 31.47 18.32 32.02C18.32 32.53 17.92 32.86 17.15 32.86C16.5 32.86 15.79 32.54 15.27 32.05L14.42 33.07C15.14 33.76 16.12 34.14 17.12 34.14ZM21.1502 34H22.6302V26.6H21.1502V34ZM24.451 34H28.941V32.76H25.931V26.6H24.451V34ZM30.585 34H32.345L34.615 26.6H33.105L32.145 30.2C31.925 31.03 31.765 31.76 31.525 32.6H31.475C31.245 31.76 31.075 31.03 30.845 30.2L29.875 26.6H28.315L30.585 34ZM35.4764 34H40.1264V32.76H36.9564V30.79H39.5464V29.54H36.9564V27.83H40.0164V26.6H35.4764V34ZM41.6288 34H43.1088V31.21H44.1988C45.7488 31.21 46.9788 30.49 46.9788 28.84C46.9788 27.14 45.7488 26.6 44.1988 26.6H41.6288V34ZM43.1088 30.04V27.78H44.0588C45.0188 27.78 45.5388 28.05 45.5388 28.84C45.5388 29.63 45.0188 30.04 44.0588 30.04H43.1088ZM45.6488 34H47.2988L44.9588 29.9L43.9288 30.83L45.6488 34Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1618_59807",
    x: 0.366211,
    y: 1.18204,
    width: 61.4922,
    height: 61.6346,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1618_59807"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1618_59807",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1618_59807",
    x1: 9,
    y1: 8.5,
    x2: 53,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageMembershipSilverMain);
export default __webpack_public_path__ + "static/media/image__membership-silver--main.fa453e8ea30884b9c36c92758a9482ff.svg";
export { ForwardRef as ReactComponent };